import React from "react";
import { Colors } from "../../config/Constants";
import {
  ChangePinIcon,
  ProfileIcon,
  EntitlementIcon,
  LogoutIcon,
  FaqIcon,
} from "../Sidebar/IconsList";

const ProfileListIcons = ({ path }) => {
  const fill1 = Colors.brandOne;
  const fill2 = Colors.brandTwo;
  const fillStroke = Colors.white;

  const getIcon = (path) => {
    switch (path) {
      case "profile":
        return (
          <ProfileIcon fill1={fill1} fill2={fill2} fillStroke={fillStroke} />
        );
      case "pin":
        return (
          <ChangePinIcon fill1={fill1} fill2={fill2} fillStroke={fillStroke} />
        );
      case "entitlements":
        return (
          <EntitlementIcon
            fill1={fill1}
            fill2={fill2}
            fillStroke={fillStroke}
          />
        );
      case "faqs":
        return <FaqIcon fill1={fill1} fill2={fill2} fillStroke={fillStroke} />;
      case "logout":
        return (
          <LogoutIcon fill1={fill1} fill2={fill2} fillStroke={fillStroke} />
        );
      default:
        return (
          <ChangePinIcon fill1={fill1} fill2={fill2} fillStroke={fillStroke} />
        );
    }
  };
  return <>{getIcon(path)}</>;
};

export default ProfileListIcons;
